export class SrStatusRequest {
  body: SrStatusRequestBody = new SrStatusRequestBody();
}

export class SrStatusRequestBody {
  ProcessName: string = 'DC Community Portal SR Process Wrapper WF';
  DCMethod: string = 'SR_STATUS_UPDATE';
  DCLoginName: string = '';
  DCLanguage: string = 'ENU';
  DCIncomingHierarchy: SrStatusIncomingHierarchy = new SrStatusIncomingHierarchy();
}

export class SrStatusIncomingHierarchy {
  MessageId: string = '';
  IntObjectName: string = 'DC Community Portal SR Upsert IO';
  MessageType: string = 'Integration Object';
  IntObjectFormat: string = 'Siebel Hierarchical';
  'ListOfDC Community Portal SR Upsert IO': SrStatusList = new SrStatusList();
}

export class SrStatusList {
  'DC Community Portal SR': SrStatusServiceRequest = new SrStatusServiceRequest();
}

export class SrStatusServiceRequest {
  'SR Number': string = '';
  Status: string = '';
}
